"use strict";
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
Object.defineProperty(exports, "__esModule", { value: true });
var squared_difference_1 = require("../../ops/squared_difference");
var tensor_1 = require("../../tensor");
tensor_1.Tensor.prototype.squaredDifference = function (b) {
    return squared_difference_1.squaredDifference(this, b);
};
//# sourceMappingURL=squared_difference.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@tensorflow/tfjs-core/dist/public/chained_ops/squared_difference.js
 ** module id = 1079
 ** module chunks = 0
 **/